// src/components/FirmwareContent.tsx

// 第三方
import React from 'react'
import { Layout, message, Tabs } from 'antd'

// 自定义
import AppAllFiles from './firmware/AppAllFiles'
import AppPanel from './firmware/AppPanel'
import AppPanel4PC from './firmware/AppPanel4PC'
import AppPanel4Ios from './firmware/AppPanel4Ios'
import FmAllFiles from './firmware/FmAllFiles'
import FmPanel from './firmware/FmPanel'
import AppAllFiles4Pc from './firmware/AppAllFiles4Pc'
import AppAllFiles4Ios from './firmware/AppAllFiles4Ios'
import { FileItem } from './firmware/FileItem'

const { Content } = Layout

interface FirmwareContentProps {
    trans: (key: string) => string
    handleError: (title: string, info: string) => void
    handleConfirm: (
        title: string,
        info: string,
        op: () => void
    ) => void
    updateFileList: (upFm: boolean, upApp: boolean) => void
    fileList: FileItem[]
    appList: FileItem[]
    appList4Android: FileItem[]
    appList4Pc: FileItem[]
    appList4Ios: FileItem[]
}

interface FirmwareContentState {
    showUpgradePanel: boolean
}

export default class FirmwareContent extends React.Component<
    FirmwareContentProps,
    FirmwareContentState
> {

    state: FirmwareContentState = {
        showUpgradePanel: false
    }

    notify = (msg: string): void => {
        message.success(msg)
    }

    openUpgradePanel = (): void => {
        console.log('弹出升级面板')

        this.setState({
            showUpgradePanel: true
        })
    }

    closeUpgradePanel = (): void => {
        console.log('关闭升级面板')

        this.setState({
            showUpgradePanel: false
        })
    }

    render(): React.ReactNode {
        const { trans: t } = this.props
        return (
            <Content
                style={{
                    margin: '4px',
                    padding: '6px',
                    background: 'var(--content-bg)',
                    minHeight: '280px',
                }}
            >
                <Tabs
                    defaultActiveKey="firmware"
                    items={[
                        {
                            key: 'firmware',
                            label: t('firmware'),
                            children: (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 16,
                                        width: '100%',
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        {this.renderUpgradePanelFirmware()}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        {this.renderUpgradePanelFmList()}
                                    </div>
                                </div>
                            ),
                        },
                        {
                            key: 'android',
                            label: t('android'),
                            children: (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 16,
                                        width: '100%',
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        {this.renderUpgradePanelAndroid()}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        {this.renderAndroidAppList()}
                                    </div>
                                </div>
                            ),
                        },
                        {
                            key: 'pc',
                            label: t('pc'),
                            children: (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 16,
                                        width: '100%',
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        {this.renderUpgradePanelPC()}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        {this.renderPcAppList()}
                                    </div>
                                </div>
                            ),
                        },
                        {
                            key: 'ios',
                            label: t('ios'),
                            children: (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 16,
                                        width: '100%',
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        {this.renderUpgradePanelIos()}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        {this.renderIosAppList()}
                                    </div>
                                </div>
                            ),
                        },
                    ]}
                />
            </Content>
        )
    }

    /** 渲染固件升级面板 */
    renderUpgradePanelFirmware(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <FmPanel
                confirm={t('confirm')}
                trans={t}
                handleError={this.props.handleError}
                updateFileList={this.props.updateFileList}
                notify={this.notify}
            />
        )
    }

    /** 渲染固件文件列表 */
    renderUpgradePanelFmList(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <FmAllFiles
                trans={t}
                fileList={this.props.fileList}
                notify={this.notify}
                handleError={this.props.handleError}
                handleConfirm={this.props.handleConfirm}
                updateFileList={this.props.updateFileList}
            />
        )
    }

    /** 渲染安卓应用升级面板 */
    renderUpgradePanelAndroid(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <AppPanel
                confirm={t('confirm')}
                trans={t}
                handleError={this.props.handleError}
                updateFileList={this.props.updateFileList}
                notify={this.notify}
            />
        )
    }

    /** 渲染PC应用升级面板 */
    renderUpgradePanelPC(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <AppPanel4PC
                confirm={t('confirm')}
                trans={t}
                handleError={this.props.handleError}
                updateFileList={this.props.updateFileList}
                notify={this.notify}
            />
        )
    }

    /** 渲染苹果应用升级面板 */
    renderUpgradePanelIos(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <AppPanel4Ios
                confirm={t('confirm')}
                trans={t}
                handleError={this.props.handleError}
                updateFileList={this.props.updateFileList}
                notify={this.notify}
            />
        )
    }

    /** 渲染应用列表面板(安卓) */
    renderAndroidAppList(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <AppAllFiles
                trans={t}
                fileList={this.props.appList4Android}
                notify={this.notify}
                handleError={this.props.handleError}
                handleConfirm={this.props.handleConfirm}
                updateFileList={this.props.updateFileList}
            />
        )
    }

    /** 渲染应用列表面板(PC) */
    renderPcAppList(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <AppAllFiles4Pc
                trans={t}
                fileList={this.props.appList4Pc}
                notify={this.notify}
                handleError={this.props.handleError}
                handleConfirm={this.props.handleConfirm}
                updateFileList={this.props.updateFileList}
            />
        )
    }

    /** 渲染应用列表面板(苹果) */
    renderIosAppList(): React.ReactNode {
        const { trans: t } = this.props

        return (
            <AppAllFiles4Ios
                trans={t}
                fileList={this.props.appList4Ios}
                notify={this.notify}
                handleError={this.props.handleError}
                handleConfirm={this.props.handleConfirm}
                updateFileList={this.props.updateFileList}
            />
        )
    }
}